var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lby-gossip-item",on:{"click":_vm.gossipInfo}},[_c('h2',[_vm._v("标题")]),_c('div',{staticClass:"lby-gossip-title"},[_vm._v(_vm._s(_vm.showTitle))]),_c('div',{staticClass:"lby-gossip-createTime"},[_vm._v(_vm._s(_vm.gossip.createTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }